<template>
  <DataTable
    v-if="isDataLoaded"
    :value="accesData"
    sortField="dateAction"
    :sortOrder="-1"
    responsiveLayout="scroll"
  >
    <Column
      field="accedeParDescription"
      header="Intervenant"
      :sortable="true"
    ></Column>
    <Column field="accedeLe" header="DateAction" :sortable="true"></Column>
    <Column field="referenceSite" header="Site"></Column>
    <Column field="action" header="Action"></Column>
  </DataTable>
  <div v-else>
    <Skeleton/>
  </div>
  <h3>Nombre d'actions : {{ nombreActions }}</h3>
</template>

<script>
import commun from "../../../commun";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "SujetTableAcces",
  emits: ["createur", "dateCreation", "isDataLoaded"],
  data() {
    return {
      accesData: [],
      columns: null,
      isDataLoaded: false,
    };
  },
  computed: {
    ...mapGetters({
        nom: "sujet/nom",
        profil: 'cardex/profil',
    }),
    nombreActions() {
      return this.accesData.length;
    },
    createur() {
      return this.accesData.length > 0
        ? this.accesData[this.accesData.length - 1]["accedeParDescription"]
        : "";
    },
    dateCreation() {
      return this.accesData.length > 0
        ? this.accesData[this.accesData.length - 1]["accedeLe"]
        : "";
    },
  },
  watch: {
    accesData() {
      if (this.accesData != null) {
        this.accesData.forEach((acces) => {
          acces.accedeLe = commun.formatDateHeure(acces.accedeLe);
        });

        this.isDataLoaded = true;
        this.$emit("isDataLoaded", this.isDataLoaded);
        this.$emit("dateCreation", this.dateCreation);
        this.$emit("createur", this.createur);
      }
    },
  },
  mounted() {
    axios.defaults.headers.common["cleProfil"] = this.profil.cle;

    this.$store
      .dispatch("sujet/obtenirAccesAction", {
        cle: this.$route.params.cle,
        site: this.$route.params.site,
      })
      .then((res) => {
        this.accesData = res.data.liste;
      });
  },
};
</script>

<style scoped>
.p-datatable::v-deep(td){
  padding: 0.7rem !important;
}

@media print {
  .p-datatable::v-deep(td){
    padding: 1rem !important;
  }
}
</style>